import fetch from 'utils/fetch';

export function agentIpFeeLogList( startTime,endTime,agent,pageSize,currentPage) {
    const data = {
        startTime,
        endTime,
        agent,
        pageSize,
        currentPage
    };
    return fetch({
        url: '/agentIpFeeLogList',
        method: 'get',
        params : data
    });
}



// WEBPACK FOOTER //
// ./src/api/agentIpFeeLog.js